<template>
    <h1>404</h1>
</template>

<script>
    export default {
        name: "NotFoundZh"
    }
</script>

<style scoped>

</style>